import { CONST_AWS_API, DEFAULT_IMAGE, API } from 'src/app/core/constants';
import { dedupedPost } from 'src/app/core/utils/api-dedupe.util';
import { AppService } from '../services/app.service';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Observable } from 'rxjs';
import { CommanSubscribeService } from '../services/comman-subscribe.service';
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { StorageService } from './../../core/services/storage.service';
import { GroupPreferenceService } from '../services/group-preference.service';
import { Subscription } from 'rxjs';
import { Title } from '@angular/platform-browser';
import { LandingPageService } from '../services/landing-page.service';
declare var fbq: any;

@Injectable({
    providedIn: 'root'
})
export class ChannelWebpageGuard implements CanActivate, CanActivateChild {

    routerevents: any;
    snapshot: RouterStateSnapshot;
    defaultSettingsData = {
        main_bg_color: environment.clientDetails.main_bg_color,
        bg_primary_color: environment.clientDetails.bg_primary_color,
        bg_secondary_color: environment.clientDetails.bg_secondary_color,
        bg_tertiary_color: environment.clientDetails.bg_tertiary_color,
        font_primary_color: environment.clientDetails.font_primary_color,
        font_secondary_color: environment.clientDetails.font_secondary_color,
        font_tertiary_color: environment.clientDetails.font_tertiary_color,
        fs_main_title: "20px",
        fs_sub_title: "16px",
        fs_sentence: "14px",
        card_shape: "round",
        font_family: "'Roboto', sans-serif",
        is_preview: false,
        form_bg_color: environment.clientDetails.footer_bg_primary_color,
        form_font_secondary_color: environment.clientDetails.form_font_secondary_color,
        footer_bg_primary_color: environment.clientDetails.footer_bg_primary_color,
        footer_font_primary_color: environment.clientDetails.footer_font_primary_color,
        footer_font_secondary_color: environment.clientDetails.footer_font_secondary_color,
        subs_bg_primary_color: environment.clientDetails.bg_primary_color,
        subs_bg_secondary_color: environment.clientDetails.bg_secondary_color,
        subs_font_tertiary_color: environment.clientDetails.font_primary_color,
        form_bg_primary_color: environment.clientDetails.bg_primary_color,
        // subs_fs_main_title: "20px",
        // subs_fs_sub_title: "16px",
        // subs_fs_sentence: "14px",
        // subs_font_primary_color: "#ffffff",
        // subs_font_secondary_color: "#fff",
        // subs_font_tertiary_color: "#fff"
        space_main_bg_color: environment.communityDefaultColors.space_main_bg_color,
        space_bg_primary_color: environment.communityDefaultColors.space_bg_primary_color,
        space_bg_secondary_color:environment.communityDefaultColors.space_bg_secondary_color,
        space_font_main_color: environment.communityDefaultColors.space_font_main_color,
        space_font_primary_color: environment.communityDefaultColors.space_font_primary_color,
        space_font_secondary_color: environment.communityDefaultColors.space_font_secondary_color,
        space_button_primary_color: environment.communityDefaultColors.space_button_primary_color,
        space_button_secondary_color: environment.communityDefaultColors.space_button_secondary_color,
        space_button_font_primary_color:environment.communityDefaultColors.space_button_font_primary_color,
        space_button_font_secondary_color: environment.communityDefaultColors.space_button_font_secondary_color,

        event_bg_main_color:environment.eventDefaultColors.event_bg_main_color,
        event_bg_primary_color:environment.eventDefaultColors.event_bg_primary_color,
        event_bg_secondary_color:environment.eventDefaultColors.event_bg_secondary_color,
        event_font_main_color:environment.eventDefaultColors.event_font_main_color,
        event_font_primary_color:environment.eventDefaultColors.event_font_primary_color,
        event_font_secondary_color:environment.eventDefaultColors.event_font_secondary_color,
        event_button_bg_primary_color:environment.eventDefaultColors.event_button_bg_primary_color,
        event_button_bg_secondary_color:environment.eventDefaultColors.event_button_bg_secondary_color,
        event_button_font_primary_color:environment.eventDefaultColors.event_button_font_primary_color,
        event_button_font_secondary_color:environment.eventDefaultColors.event_button_font_secondary_color,
        event_card_bg_color:environment.eventDefaultColors.event_card_bg_color,
        event_card_font_color:environment.eventDefaultColors.event_card_font_color,
        // merchandise colors
        merchandise_bg_main_color:environment.merchandiseDefaultColors.merchandise_bg_main_color,
        merchandise_bg_primary_color:environment.merchandiseDefaultColors.merchandise_bg_primary_color,
        merchandise_bg_secondary_color:environment.merchandiseDefaultColors.merchandise_bg_secondary_color,
        merchandise_font_main_color:environment.merchandiseDefaultColors.merchandise_font_main_color,
        merchandise_font_primary_color:environment.merchandiseDefaultColors.merchandise_font_primary_color,
        merchandise_font_secondary_color:environment.merchandiseDefaultColors.merchandise_font_secondary_color,
        merchandise_button_bg_primary_color:environment.merchandiseDefaultColors.merchandise_button_bg_primary_color,
        merchandise_button_bg_secondary_color:environment.merchandiseDefaultColors.merchandise_button_bg_secondary_color,
        merchandise_button_font_primary_color:environment.merchandiseDefaultColors.merchandise_button_font_primary_color,
        merchandise_button_font_secondary_color:environment.merchandiseDefaultColors.merchandise_button_font_secondary_color,
        merchandise_card_bg_color:environment.merchandiseDefaultColors.merchandise_card_bg_color,
        merchandise_card_font_color:environment.merchandiseDefaultColors.merchandise_card_font_color
    };
    getCurrency: any;
    getCurrencytype: any;
    currentLocation: any;
    userInfo: any = {};
    userInfoSubscription: Subscription;
    isSubChannelPresent: boolean = false;
    webChannelName: string = ''
    // Tracks which channel+group scope (network, a specific /channel/xyz sub-channel, and/or an
    // active group) settingsData was last fetched for, so navigating between scopes client-side
    // refetches instead of silently keeping stale channelInfo (and stale colors) until a hard
    // refresh clears icWebpageSettingsData. Originally only tracked the /channel/xyz sub-channel
    // case, which meant switching between groups (or group <-> network) under the same channel
    // never refetched GET_EVENT_WEBPAGE, so the previous scope's colors stuck around until a
    // full reload re-ran everything from scratch. this.commanSubscribeService.activeGroupId is
    // set synchronously above (or reset to 0) before getPerformerInfo runs, so it always reflects
    // the target route's group by the time this key is computed. The initial '' is safe even
    // though it also represents "network scope, no group" - the empty-cache check below still
    // guarantees the very first fetch happens regardless of this value.
    lastFetchedChannelKey: string = '';
    trackingCodes: any;
    trackingCodeInfoSubscription: Subscription;
    deviceData: Subscription;
    deviceType: any;
    constructor(private commanSubscribeService: CommanSubscribeService, private router: Router,
        private activatedRoute: ActivatedRoute, private ngxLoader: NgxUiLoaderService,
        private storageService: StorageService,
        private route: ActivatedRoute, private titleService: Title,
        private appService: AppService,
        private landingPageService: LandingPageService,
        private groupPreferenceService: GroupPreferenceService
    ) {
        this.userInfo = this.commanSubscribeService.userInfo;
        this.userInfoSubscription = this.commanSubscribeService.getUserInfo().subscribe(response => {
            this.userInfo = response;
        });
        this.trackingCodes = this.commanSubscribeService.trackingCodeInfo;
        this.trackingCodeInfoSubscription = this.commanSubscribeService.getTrackingCode().subscribe(response => {
            if (Object.keys(response).length == 0) {
                if (this.deviceType == 'browser')
                    window.location.reload();
                if (this.trackingCodes && this.trackingCodes.google_analytics_code) {
                    window[`ga-disable-${this.trackingCodes.google_analytics_code}`] = true;
                }
                if (this.trackingCodes && this.trackingCodes.facebook_pixel_code) {
                    fbq('set', 'autoConfig', false, this.trackingCodes.facebook_pixel_code);
                }
            }
        })
        this.deviceType = this.commanSubscribeService.deviceType;
        this.deviceData = this.commanSubscribeService.getAppType().subscribe(response => {
            this.deviceType = response;
        })
    }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

        // Album URLs contain "/album/channel/<category>/<slug>" — that is not a sub-channel page. Treating it as one
        // sent the video slug (with its query string) as a channel name to getWebPageSettings.
        if (state.url.includes('/channel/') && !state.url.includes('/album/channel/')) {

            let urlArray = state.url.split('/channel/')[1];
            if (urlArray.includes('/')) {
                if (urlArray.includes('/preview?')) {
                    let split = urlArray.split("/")[0];
                    this.webChannelName = split;
                } else {
                    let split = urlArray.split("/")
                    this.webChannelName = split[split.length - 1];
                }
            } else if (urlArray.includes('?')) {
                let split = urlArray.split("?")[0];
                this.webChannelName = split;
            } else {
                this.webChannelName = urlArray;
            }
            this.isSubChannelPresent = true;
        } else {
            this.isSubChannelPresent = false
        }
        //console.log(state.url)
        let userInfo = this.commanSubscribeService.userInfo;
        let user_Info = this.storageService.getItem("user_Info") || {};
        return new Promise(res => {
            if (Object.keys(userInfo).length == 0 && Object.keys(user_Info).length != 0 && !state.url.includes('preview')) {
                this.ngxLoader.start();
                // Extract channel name and currency for performer info pre-fetch
                let channel_name = state.url.split("/")[1];
                if (channel_name[channel_name.length - 1] == "#") channel_name = channel_name.slice(0, -1);
                let channelName = channel_name.includes('?') ? channel_name.split('?')[0] : channel_name;
                let locInfo = this.commanSubscribeService.locationInfo;
                let currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : (this.storageService.getItem('current_location') || {});
                let getCurrency = this.storageService.getItem('currency');
                let code = currentLocation?.currency?.code || '';
                let currentCode = code.includes('"') ? JSON.parse(code) : code;
                let localCurrency = getCurrency && getCurrency.includes('"') ? JSON.parse(getCurrency) : getCurrency;
                let perfData = {
                    headers: { "Content-Type": "application/json", "x-api-key": environment.AWS_Cognito.X_Api_Key },
                    response: true,
                    body: { "channel_name": channelName, "currency": localCurrency ? localCurrency : currentCode, "user_id": this.userInfo.id }
                };
                const callGetUser = (organizationId: any, perfResponse?: any) => {
                    let myInit = {
                        headers: {
                            "Content-Type": "application/json",
                            "x-api-key": environment.AWS_Cognito.X_Api_Key,
                            "Authorization": `Bearer ${user_Info.access_token}`
                        },
                        response: true,
                        body: { organization_id: organizationId || 0 }
                    };
                    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
                        this.ngxLoader.stop();
                        let userInfo = response.data.user;
                        userInfo.signedIn = true;
                        userInfo.access_token = userInfo.session_token;
                        userInfo.is_profile_completed = true;
                        this.commanSubscribeService.sendUserInfo(userInfo);
                        this.getPerformerInfo(state.url, perfResponse).then(() => {
                            this.redirectToPreferredGroupIfApplicable(state.url);
                            res(true);
                        });
                    }).catch(() => {
                        this.ngxLoader.stop();
                        this.getPerformerInfo(state.url, perfResponse).then(() => res(true));
                    });
                };
                // Step 1: Get performer info first to obtain organization_id
                AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, perfData)
                    .then(perfResponse => {
                        const organizationId = perfResponse.data?.Data?.[0]?.organization_id || 0;
                        callGetUser(organizationId, perfResponse);
                    })
                    .catch(() => {
                        callGetUser(0);
                    });
            } else {
                const ORG_RESERVED_KEYWORDS = new Set([
                    'signin', 'channelSearch', 'preview', 'sign-up', '404',
                    'my-library', 'playlist', 'contactus', 'privacypolicy',
                    'cookiepolicy', 'termsandconditions', 'subscription-list',
                    'event', 'community', 'merchandise', 'album', 'album-video', 'channel', 'fastChannel',
                    'user-dashboard', 'video', 'audio', 'recorded-video'
                ]);
                let urlParts = state.url.split('/');
                let potentialGroupSlug = urlParts[2] ? urlParts[2].split('?')[0] : '';
                if (potentialGroupSlug && !ORG_RESERVED_KEYWORDS.has(potentialGroupSlug) && Object.keys(this.commanSubscribeService.perfomerInfoData).length > 0) {
                    let cachedGroups = this.commanSubscribeService.perfomerInfoData?.data?.Data[0]?.groups || [];
                    let matchedGroup = cachedGroups.find((g: any) => g.group_slug === potentialGroupSlug);
                    if (!matchedGroup) {
                        this.router.navigate(['/page-not-found/404'], { replaceUrl: true, queryParams: { from: state.url } });
                        res(false);
                        return;
                    }
                    this.commanSubscribeService.setActiveGroup(matchedGroup);
                } else if (this.commanSubscribeService.activeGroupId) {
                    // Navigating to a non-group (network-level) route - clear the stale group
                    // context left over from a previous navigation, so the scope key below (and
                    // the network_group_id sent to GET_EVENT_WEBPAGE) correctly reflect "no group"
                    // instead of continuing to request the previous group's colors.
                    this.commanSubscribeService.activeGroupId = 0;
                    this.commanSubscribeService.activeGroupSlug = '';
                    this.commanSubscribeService.activeGroup = null;
                }
                this.getPerformerInfo(state.url).then(() => {
                    this.redirectToPreferredGroupIfApplicable(state.url);
                    res(true);
                });
            }
        });
    }

    // Once-per-session, non-blocking: if an already-authenticated fan lands on a plain
    // /:channelName URL (no :groupName) and has a saved preferred group for this org, send them
    // there instead. Runs strictly AFTER getPerformerInfo has resolved for THIS url, so
    // perfomerInfoData is guaranteed fresh for the org actually being visited (never a stale
    // previous org's data) - deliberately non-blocking rather than woven into getPerformerInfo's
    // existing response handling, to avoid restructuring that large, heavily shared method.
    private redirectToPreferredGroupIfApplicable(url: string): void {
        const urlParts = url.split('/');
        const potentialGroupSlug = urlParts[2] ? urlParts[2].split('?')[0] : '';
        if (potentialGroupSlug) return; // already on a group (or reserved-keyword) URL - nothing to do

        const userInfo = this.commanSubscribeService.userInfo;
        if (!userInfo?.id) return; // guest - nothing to redirect

        const orgId = this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id;
        if (!orgId || this.storageService.hasOfferedGroupRedirect(orgId)) return;
        this.storageService.markGroupRedirectOffered(orgId);

        let channelName = urlParts[1] ? urlParts[1].split('?')[0] : '';
        if (channelName[channelName.length - 1] == '#') channelName = channelName.slice(0, -1);
        const groups = this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0]?.groups || [];

        this.groupPreferenceService
            .resolvePreferredGroupSlug(userInfo.id, orgId, channelName, groups)
            .subscribe((groupSlug) => {
                if (groupSlug) {
                    this.router.navigate(['/' + channelName + '/' + groupSlug], { replaceUrl: true });
                }
            });
    }

    // Returns a Promise that resolves once settingsData has actually been updated (or once we've
    // determined no update is needed) - canActivate awaits this before letting navigation proceed,
    // so the target component never mounts against a stale channelInfo from the previous scope.
    getPerformerInfo(url, preloadedResponse?: any): Promise<void> {
      return new Promise<void>((resolve) => {
        let channelKey = `${this.isSubChannelPresent ? this.webChannelName : ''}|group:${this.commanSubscribeService.activeGroupId || 0}`;
        const scopeChanged = this.lastFetchedChannelKey !== channelKey;
        if (Object.keys(this.commanSubscribeService.icWebpageSettingsData).length == 0 || scopeChanged) {
            let locInfo = this.commanSubscribeService.locationInfo;
            this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
            if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
                this.commanSubscribeService.getCurrentLocation((val: any, json: any) => {
                    //console.log(json);
                    if (val == "fail") {
                        this.currentLocation = this.currentLocation ? this.currentLocation : {};
                    } else {
                        this.currentLocation = json;
                    }
                });
            }
            this.getCurrency = this.storageService.getItem('currency');
            this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
            let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
            let currentCode = code.includes('\"') ? JSON.parse(code) : code;
            let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
            let channel_name = url.split("/")[1];
            if (channel_name[channel_name.length - 1] == "#") {
                channel_name = channel_name.slice(0, -1);
            }
            let channelName = channel_name.includes('?') ? channel_name.split('?')[0] : channel_name;
            let data = {
                headers: {
                    "Content-Type": "application/json",
                    "x-api-key": environment.AWS_Cognito.X_Api_Key
                },
                response: true,
                body: {
                    "channel_name": channelName,
                    "currency": localCurrency ? localCurrency : currentCode,
                    "user_id": this.userInfo.id
                }
            }
            if (!preloadedResponse) {
                this.ngxLoader.start();
            }
            const apiCall = preloadedResponse
                ? Promise.resolve(preloadedResponse)
                : dedupedPost(AWS_API.post.bind(AWS_API), environment.AWS_Cognito.apiName, CONST_AWS_API.GET_PERFORMER_INFO, data);
            apiCall.then(response => {
                // if(response.data.Data.length==0){
                //     this.ngxLoader.stop();
                //     this.router.navigate(['/page-not-found/404'], { replaceUrl: true, queryParams: { from: url } });
                //     return;
                // }
                this.titleService.setTitle(response.data.Data[0].channel_display_name);
                console.log("pagetitle",response,response.data.Data[0].channel_display_name);
                if(response.data.Data.length==0 && url.split('/').length <= 2){
                    this.ngxLoader.stop();
                    this.router.navigate(['/page-not-found/404'], { replaceUrl: true, queryParams: { from: url } });
                    resolve();
                    return;
                }
                else{
                if (response.data.statusCode === '200') {
                    console.log("Performer Info: ", response.data.Data[0]);
                    this.commanSubscribeService.sendPerfomerInfo(response);

                    const ORG_RESERVED_KEYWORDS = new Set([
                        'signin', 'channelSearch', 'preview', 'sign-up', '404',
                        'my-library', 'playlist', 'contactus', 'privacypolicy',
                        'cookiepolicy', 'termsandconditions', 'subscription-list',
                        'event', 'community', 'merchandise', 'album', 'album-video', 'channel', 'fastChannel',
                        'user-dashboard', 'video', 'audio', 'recorded-video'
                    ]);
                    let urlParts = url.split('/');
                    let potentialGroupSlug = urlParts[2] ? urlParts[2].split('?')[0] : '';
                    if (potentialGroupSlug && !ORG_RESERVED_KEYWORDS.has(potentialGroupSlug)) {
                        let groups = response.data.Data[0]?.groups || [];
                        let matchedGroup = groups.find((g: any) => g.group_slug === potentialGroupSlug);
                        if (matchedGroup) {
                            this.commanSubscribeService.setActiveGroup(matchedGroup);
                            // On a first load of a group URL the group is only known from this
                            // response, so the key computed above still says group 0. The settings
                            // request below is made for this group; without updating the key its
                            // response was discarded as stale and canActivateChild fetched
                            // performer info + settings a second time.
                            channelKey = `${this.isSubChannelPresent ? this.webChannelName : ''}|group:${this.commanSubscribeService.activeGroupId || 0}`;
                        } else {
                            this.ngxLoader.stop();
                            this.router.navigate(['/page-not-found/404'], { replaceUrl: true, queryParams: { from: url } });
                            resolve();
                            return;
                        }
                    }

                    let performerInfo = response.data.Data[0] && response.data.Data[0].org_info ? response.data.Data[0].org_info : {};
                    let perInfo = response.data.Data[0] && response.data.Data[0].performer_details ? response.data.Data[0].performer_details : {};
                    this.trackingCodes = perInfo.tracking_code ? JSON.parse(perInfo.tracking_code) : '';
                    if (this.trackingCodes && this.trackingCodes.google_analytics_code) {
                        this.loadGoogleAnalytics(this.trackingCodes.google_analytics_code);
                    }
                    if (this.trackingCodes && this.trackingCodes.google_tag_manager) {
                        this.loadGoogleTagManager(this.trackingCodes.google_tag_manager);
                    }
                    if (this.trackingCodes && this.trackingCodes.facebook_pixel_code) {
                        this.loadFBPixelCode(this.trackingCodes.facebook_pixel_code);
                    }
                    // let organizationName = performerInfo.organization_name;
                    // organizationName = organizationName ? organizationName.split(' ').join('-') : "";
                    let myInit = {
                        headers: {
                            'x-api-key': environment.AWS_Cognito.X_Api_Key
                        },
                        response: true,
                        body: this.isSubChannelPresent ? {
                            "channel_name": this.webChannelName,
                            "organization_id": performerInfo.id,
                            "network_group_id": this.commanSubscribeService.activeGroupId

                        } : {
                            "organization_id": performerInfo.id,
                            "network_group_id": this.commanSubscribeService.activeGroupId
                        }
                    }
                    dedupedPost(AWS_API.post.bind(AWS_API), environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_WEBPAGE, myInit).then(response => {
                       
                        this.ngxLoader.stop();
                        let settingsData: any = {};
                        // let webSettings:any = (this.isSubChannelPresent && response.data.Data[0].template == 1 ) ? response.data.Data[0].settings : response.data.Data[0]
                        // if (response.data && response.data.statusCode == '200') {
                        let webSettings = response.data.Data ? response.data.Data[0] : {};
                        if (url.includes('preview')) {
                            if (webSettings && webSettings.webpage_settings_preview && Object.keys(webSettings.webpage_settings_preview).length > 0) {
                                settingsData = JSON.parse(webSettings.webpage_settings_preview);
                            } else {
                                settingsData = this.defaultSettingsData;
                            }
                            settingsData.is_preview = true;
                        } else {
                            if (webSettings && webSettings.webpage_settings_publish && Object.keys(webSettings.webpage_settings_publish).length > 0) {
                                settingsData = JSON.parse(webSettings.webpage_settings_publish);
                            } else {
                                settingsData = this.defaultSettingsData;
                            }
                            settingsData.is_preview = false;
                        }

                        if (settingsData.fs_main_title) {
                            settingsData.fs_main_title = settingsData.fs_main_title + "px";
                        }
                        if (settingsData.fs_sentence) {
                            settingsData.fs_sentence = settingsData.fs_sentence + "px";
                        }
                        if (settingsData.fs_sub_title) {
                            settingsData.fs_sub_title = settingsData.fs_sub_title + "px";
                        }

                        if (settingsData.subs_fs_main_title) {
                            settingsData.subs_fs_main_title = settingsData.subs_fs_main_title + "px";
                        }
                        if (settingsData.subs_fs_sentence) {
                            settingsData.subs_fs_sentence = settingsData.subs_fs_sentence + "px";
                        }
                        if (settingsData.subs_fs_sub_title) {
                            settingsData.subs_fs_sub_title = settingsData.subs_fs_sub_title + "px";
                        }
                        if (settingsData.form_fs_main_title) {
                            settingsData.form_fs_main_title = settingsData.form_fs_main_title + "px";
                        }
                        if (settingsData.font_family) {
                            let data: any = this.commanSubscribeService.fontFamilyList.filter(a => a.id == settingsData.font_family);
                            if (data && data.length > 0) {
                                var fileref = document.createElement("link");
                                fileref.setAttribute("rel", "stylesheet");
                                fileref.setAttribute("type", "text/css");
                                fileref.setAttribute("href", data[0].link);
                                document.getElementsByTagName("head")[0].appendChild(fileref);
                                settingsData.font_family = data[0].code;
                            }
                        }
                        if (Object.keys(settingsData).length == 0) {
                            settingsData = this.defaultSettingsData;
                        }
                        //console.log("settingsData", settingsData);
                        this.storageService.setItem("channelName", this.router.url.split('/')[1])
                        //console.log(localStorage.getItem("ThemelocalData"),)
                        let channel = {
                            org_id: performerInfo.id,
                            channel_id: webSettings && webSettings.channel_id ? webSettings.channel_id : 0,
                            channel_display_name: webSettings && webSettings.channel_display_name ? webSettings.channel_display_name : "",
                            channel_name: webSettings && webSettings.channel_name ? webSettings.channel_name : "",
                            subscription: webSettings && webSettings.subscription === 1 ? 1 : 0,
                            template: webSettings && webSettings.template === 1 ? 1 : 0,
                            channel_logo: webSettings && webSettings.logo ? webSettings.logo : ""
                        }

                        settingsData.channelInfo = channel;
                        const hasEventKey = Object.keys(settingsData || {}).some(key => key.startsWith('event_'));
                        if(!hasEventKey) {
                        settingsData = {...settingsData, ...environment.eventDefaultColors}
                        }
                        const hasMerchKey = Object.keys(settingsData || {}).some(key => key.startsWith('merchandise_'));
                        if(!hasMerchKey) {
                        settingsData = {...settingsData, ...environment.merchandiseDefaultColors}
                        }
                        const hasSpaceKey = Object.keys(settingsData || {}).some(key => key.startsWith('space_'));
                        if(!hasSpaceKey) {
                        settingsData = {...settingsData, ...environment.communityDefaultColors}
                        }
                        settingsData.banner_image = webSettings && webSettings.banner_image ? webSettings.banner_image : DEFAULT_IMAGE.IMAGE_2;

                        // The active scope may have moved on (e.g. user navigated from this
                        // group back to network, or into a different group/channel) while this
                        // GET_EVENT_WEBPAGE request for `channelKey` was in flight. Applying a
                        // stale response now would overwrite the new scope's colors with this
                        // one's - discard it instead.
                        const currentChannelKey = `${this.isSubChannelPresent ? this.webChannelName : ''}|group:${this.commanSubscribeService.activeGroupId || 0}`;
                        if (currentChannelKey !== channelKey) {
                            resolve();
                            return;
                        }

                        this.lastFetchedChannelKey = channelKey;
                        this.commanSubscribeService.sendICWebpageThemeSettings(settingsData);
                        resolve();
                        //console.log(settingsData)
                        //     return false;
                        // } else {
                        //     if (this.userInfo && this.userInfo.id) {
                        //         this.router.navigateByUrl('/userhome');
                        //     } else {
                        //         this.router.navigateByUrl('/')
                        //     }
                        // }
                    }).catch(error => {
                        this.ngxLoader.stop();
                        // if (this.userInfo && this.userInfo.id) {
                        //     this.router.navigateByUrl('/userhome');
                        // } else {
                        //     this.router.navigateByUrl('/')
                        // }
                        resolve();
                    });


                } else {
                    resolve();
                }
            }
            }).catch(error => {
                this.ngxLoader.stop();
                // if (this.userInfo && this.userInfo.id) {
                //     this.router.navigateByUrl('/userhome');
                // } else {
                //     this.router.navigateByUrl('/')
                // }
                resolve();
            });

        } else {
            resolve();
        }
      });
    }

    canActivateChild(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        // Was a no-op before, and wasn't even wired up in the route config - child-route
        // navigations within the lazy-loaded module (e.g. subscribed-channels -> a specific
        // channel's subscription-list) never re-ran canActivate's fetch/scope-check logic.
        // Delegating to canActivate here (now paired with canActivateChild in the route config)
        // makes every such navigation re-check whether settingsData needs refetching.
        return this.canActivate(next, state);
    }

    loadGoogleAnalytics(trackingID: string): void {

        let gaScript = document.createElement('script');
        gaScript.setAttribute('async', '');
        gaScript.setAttribute('src', `https://www.googletagmanager.com/gtag/js?id=${trackingID}`);

        let gaScript2 = document.createElement('script');
        gaScript2.innerText = `window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag(\'js\', new Date());gtag(\'config\', \'${trackingID}\');`;

        document.documentElement.firstChild.appendChild(gaScript);
        document.documentElement.firstChild.appendChild(gaScript2);
    }


    loadGoogleTagManager(trackingID: string): void {

        let gaScript2 = document.createElement('script');
        gaScript2.innerText = `(function gtm(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${trackingID}')`;
        document.documentElement.firstChild.appendChild(gaScript2);
        let bodyScript = document.createElement('noscript');
        bodyScript.innerText = `<iframe src="https://www.googletagmanager.com/ns.html?id=${trackingID}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`
        document.body.appendChild(bodyScript);
    }

    loadFBPixelCode(trackingID: string): void {
        let fbScript = document.createElement('script');
        fbScript.innerText = `!function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window, document,'script','https://connect.facebook.net/en_US/fbevents.js');fbq('init', ${trackingID});fbq('track', 'PageView');`
        document.body.appendChild(fbScript);
        let bodyScript = document.createElement('noscript');
        bodyScript.innerText = `<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=${trackingID}&ev=PageView&noscript=1" />`
        document.body.appendChild(bodyScript);
    }

    ngOnDestroy() {
        if (this.routerevents) {
            this.routerevents.unsubscribe();
        }
        if (this.userInfoSubscription) {
            this.userInfoSubscription.unsubscribe();
        }
        if (this.trackingCodeInfoSubscription) {
            this.trackingCodeInfoSubscription.unsubscribe();
        }
        if (this.deviceData) {
            this.deviceData.unsubscribe();
        }
    }


}
